import { render, staticRenderFns } from "./move-board-dropdown.vue?vue&type=template&id=9e76b7f6"
import script from "./move-board-dropdown.vue?vue&type=script&lang=js"
export * from "./move-board-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports